// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"4db60996","996":"15fc9d59"}[chunkId] + ".chunk.js";
};